// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "112fe74e-dirty",
    "hash": "112fe74e",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "112fe74e-dirty",
    "semverString": null,
    "devVersion": "0.81.0",
    "branch": null
};
/* tslint:enable */
